class CollectionGrid extends HTMLElement {
  constructor() {
    super();
    this.listViewButton = document.querySelector('.switch-view-button--list');
    this.browseViewButton = document.querySelector('.switch-view-button--browse');
    this.initViewToggle();
  }

  initViewToggle() {
    if (!this.listViewButton || !this.browseViewButton) return;
    // Set initial active state based on current class
    this.updateActiveButtonState();

    // Add click listeners to buttons
    this.listViewButton.addEventListener('click', () => this.setView('list'));
    this.browseViewButton.addEventListener('click', () => this.setView('browse'));
  }

  updateActiveButtonState() {
    const isBrowseView = this.classList.contains('collection-grid--browse');
    this.listViewButton.classList.toggle('active', !isBrowseView);
    this.browseViewButton.classList.toggle('active', isBrowseView);
  }

  setView(viewType) {
    const storageKey = window.localStorageKeys?.plpView || 'plpView'; // Use global key or fallback

    if (viewType === 'browse') {
      this.classList.add('collection-grid--browse');
      this.classList.remove('collection-grid--list');

      // Update URL parameter without page reload
      const url = new URL(window.location);
      url.searchParams.set('layout', 'browse');
      window.history.replaceState({}, '', url);

      // Update localStorage
      window.localStorage.setItem(storageKey, 'browse');
    } else {
      // Assume 'list' view
      this.classList.remove('collection-grid--browse');
      this.classList.add('collection-grid--list');

      // Remove display parameter from URL
      const url = new URL(window.location);
      url.searchParams.delete('layout');
      window.history.replaceState({}, '', url);

      // Update localStorage to 'grid'
      window.localStorage.setItem(storageKey, 'grid');
    }

    this.updateActiveButtonState();
    this.trackLayoutSwitch(storageKey, viewType);
  }

  trackLayoutSwitch(storageKey, viewType) {
    const eventData = {
      link_location_id: 'plp-toggle',
    };
    eventData[storageKey] = viewType;

    Shopify.analytics.publish("product_list_layout_switched", {...eventData});
    // console.log("product_list_layout_switched published:", eventData);
  }
}

customElements.define('collection-grid', CollectionGrid);
